import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {selectInvite} from 'api/invite';
import {loadInvestInvite as load, submitInvestInvite as submit} from 'flows/invest/invite/index';
import Spinner from 'components/Spinner';

import InvestInvite from './component';

export class InvestInviteContainer extends React.Component {
  constructor() {
    super();
    this.login = this.login.bind(this);
  }
  componentDidMount() {
    this.props.load({id: this.props.params.inviteId});
  }
  login() {
    this.props.submit({id: this.props.params.inviteId});
  }
  render() {
    const {data, loaded} = this.props.invite || {};

    if (loaded) {
      return (
        <InvestInvite login={this.login} invite={data} />
      );
    }
    return (
      <Spinner />
    );
  }
}

InvestInviteContainer.propTypes = {
  load: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  invite: PropTypes.object,
  params: PropTypes.object.isRequired,
};

export const mapStore = (store, ownProps) => ({
  invite: selectInvite(store, ownProps.params.inviteId)
});

export default connect(mapStore, {load, submit})(InvestInviteContainer);



// WEBPACK FOOTER //
// ./web/flows/invest/invite/index.js